import { useEffect, useState } from 'react';
// it is used for the modal and the toast and ... for cva animations works as well as we want
const useIsFirstRender = () => {
  const [isFirstRender, setIsFirstRender] = useState(true);
  useEffect(() => {
    if (isFirstRender) {
      const renderTimeout = setTimeout(() => {
        setIsFirstRender(false);
      }, 200);
      return () => {
        clearTimeout(renderTimeout);
      };
    }
  }, []);
  return isFirstRender;
};
export default useIsFirstRender;
